import { useState, useEffect } from 'react';
import { canUseDOM } from './helper';

export const useScreenWidth = () => {
  const getWidth = () => (canUseDOM ? window.visualViewport?.width ?? window.innerWidth : 0);

  const [windowWidth, setWindowWidth] = useState(getWidth);

  useEffect(() => {
    if (!canUseDOM) return;

    const update = () => setWindowWidth(getWidth());
    update();

    // visualViewport fires its own resize event when the layout viewport changes
    // (e.g. Android URL bar toggle) even if window.innerWidth stays the same.
    const vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', update);
    }
    window.addEventListener('resize', update);

    return () => {
      if (vv) {
        vv.removeEventListener('resize', update);
      }
      window.removeEventListener('resize', update);
    };
    // eslint-disable-next-line
  }, [canUseDOM]);

  return windowWidth;
};
